import React from 'react'
import { SVGIconProps } from '../types'
const SvgFolderCompressed = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="currentColor"
    viewBox="0 -960 960 960"
    {...props}
  >
    <path d="M640-480v-80h80v80zm0 80h-80v-80h80zm0 80v-80h80v80zM447-640l-80-80H160v480h400v-80h80v80h160v-400H640v80h-80v-80zM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640v400q0 33-23.5 56.5T800-160zm0-80v-480z" />
  </svg>
)
export default SvgFolderCompressed
